/**
 * Auto-découvert par `apps/web/src/routes/modules.ts` via :
 *   import.meta.glob('../../../modules/*\/web/route.tsx', { eager: true })
 *
 * Module « Réglages » (GO Ben 20/07) — premier résident : configuration SMTP.
 */
import { lazy, Suspense, type ReactNode } from 'react';

const ReglagesPage = lazy(() => import('./pages/Reglages'));

function LoadingFallback(): ReactNode {
  return (
    <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
      Chargement des réglages…
    </div>
  );
}

const route = {
  path: 'admin',
  label: 'Réglages',
  icon: 'settings',
  element: (
    <Suspense fallback={<LoadingFallback />}>
      <ReglagesPage />
    </Suspense>
  ),
};

export default route;
